import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { t } from 'i18next'; // o desde un hook si lo necesitas
import { setErrorOcr, setToken } from '../app/store/ocrSlice';
import { setIsLoading } from '../app/store/majesticSlice';
import { handlerErrorResponse, handleResponse } from '../utils/HandlerTransformOCR';

const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_APP_API_BIOMETRICS_MAJESTIC}`,
  prepareHeaders: (headers, { endpoint, getState }) => {
    // console.log(endpoint)
    if (endpoint !== 'login') {
      headers.set('Authorization', `Bearer ${getState().ocr.token.trim()}`);
    }
    return headers;
  },
});

const baseQueryWith = async (args, contextApi, extraOptions) => {
  // console.log(contextApi.getState(), { args });

  const { checking } = contextApi.getState();

  const newArgs = {
    ...args,
    body: {
      ...args.body,
      language: checking.language.toLowerCase(),
    },
  };

  const result = await baseQuery(newArgs, contextApi, extraOptions);

  return result;
};
export const ocrApi = createApi({
  reducerPath: 'ocrApi',
  // baseQuery: fetchBaseQuery({
  //   baseUrl: `${import.meta.env.VITE_APP_API_BIOMETRICS_MAJESTIC}`,
  //   prepareHeaders: (headers, { endpoint, getState }) => {
  //     if (endpoint !== 'login') {
  //       headers.set('Authorization', `Bearer ${getState().ocr.token.trim()}`);
  //     }
  //     return headers;
  //   },
  // }),
  baseQuery: baseQueryWith,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: () => ({
        url: '/auth/login',
        method: 'post',
        // body: { username: 'john', password: 'changeme' },
      }),
      transformErrorResponse: handlerErrorResponse,
      transformResponse: (response) => response,
      // Usa onQueryStarted para manejar la logica adicional
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          // console.log(data);
          // dispatch(setToken(data.token));
        } catch (error) {
          dispatch(setIsLoading(false));
          console.log(error.error)
          dispatch(setErrorOcr(error.error));
          // console.log("error:", error);
        }
      },
    }),
    recognizeIne: builder.mutation({
      query: (params) => ({
        url: '/v1/vision/recognizeTextFromIne',
        method: 'post',
        body: params,
      }),
      transformErrorResponse: handlerErrorResponse,
      transformResponse: handleResponse,
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          console.log(data);
        } catch (error) {
          dispatch(setIsLoading(false));
          dispatch(setErrorOcr(error.error));
          // console.log(error);
        }
      },
    }),
    recognizeCedula: builder.mutation({
      query: (params) => ({
        url: '/v1/vision/recognizeTextFromID',
        method: 'post',
        body: params,
      }),
      transformErrorResponse: handlerErrorResponse,
      transformResponse: handleResponse,
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          console.log(data);
        } catch (error) {
          dispatch(setIsLoading(false));
          dispatch(setErrorOcr(error.error));
          // console.log(error);
        }
      },
    }),
    recognizePassport: builder.mutation({
      query: (image) => ({
        url: '/v1/vision/recognizeTextFromPassport',
        method: 'post',
        body: image,
      }),
      transformErrorResponse: handlerErrorResponse,
      transformResponse: handleResponse,
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          // console.log(data);
        } catch (error) {
          dispatch(setIsLoading(false));
          dispatch(setErrorOcr(error.error));
          // console.log(error);
        }
      },
    }),

    sendImageToS3: builder.mutation({
      query: (params) => ({
        url: '/majestic/aws/sendImageToS3',
        method: 'post',
        body: params,
      }),
      transformErrorResponse: handlerErrorResponse,
      transformResponse: handleResponse,
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          dispatch(setIsLoading(true));
          const { data } = await queryFulfilled;
          // dispatch(setIsLoading(false));
          // console.log(data);
          // dispatch(setToken(data.token));
        } catch (error) {
          dispatch(setIsLoading(false));
          dispatch(setErrorOcr(error.error));
          // console.log("error:", error);
        }
      },
    }),

    sendDocuments: builder.mutation({
      query: (params) => ({
        url: '/majestic/aws/sendDocuments',
        method: 'post',
        body: params,
      }),
      transformErrorResponse: handlerErrorResponse,
      transformResponse: handleResponse,
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          dispatch(setIsLoading(true));
          const { data } = await queryFulfilled;
          // dispatch(setIsLoading(false));
          // console.log(data);
          // dispatch(setToken(data.token));
        } catch (error) {
          dispatch(setIsLoading(false));
          dispatch(setErrorOcr(error.error));
          // console.log("error:", error);
        }
      },
    }),

    sendMail: builder.mutation({
      query: (params) => ({
        url: '/majestic/aws/sendMail',
        method: 'post',
        body: params,
      }),
      transformErrorResponse: handlerErrorResponse,
      transformResponse: handleResponse,
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          dispatch(setIsLoading(true));
          const { data } = await queryFulfilled;
          // dispatch(setIsLoading(false));
          // console.log(data);
          // dispatch(setToken(data.token));
        } catch (error) {
          dispatch(setIsLoading(false));
          dispatch(setErrorOcr(error.error));
          // console.log("error:", error);
        }
      },
    }),
  }),
});

// console.log(ocrApi)
export const {
  useLoginMutation,
  useRecognizeIneMutation,
  useRecognizeCedulaMutation,
  useRecognizePassportMutation,
  useSendImageToS3Mutation,
  useSendDocumentsMutation,
  useSendMailMutation,
} = ocrApi;
